import state from "./moduleVesselEquipmentBaseStationState.js";
import mutations from "./moduleVesselEquipmentBaseStationMutations.js";
import actions from "./moduleVesselEquipmentBaseStationActions.js";
import getters from "./moduleVesselEquipmentBaseStationGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
